module.exports = __webpack_public_path__ + "img/exam-card-up.5d2f2826.svg";